import { getPublicApiBaseUrl } from './publicApiBase';

/**
 * Full-page OAuth must hit the same API host axios uses (`VITE_API_URL` / `VITE_PUBLIC_API_URL`).
 * A relative `/api/...` would stay on the SPA origin (e.g. www) and never reach the backend (e.g. api).
 */
export function startSocialLogin(provider: string, nextPath?: string): void {
  const next =
    nextPath && nextPath.startsWith('/')
      ? nextPath
      : typeof window !== 'undefined'
        ? `${window.location.pathname}${window.location.search}`
        : '/';
  const path = `/api/auth/social/start/${encodeURIComponent(provider)}?next=${encodeURIComponent(next)}`;
  const apiOrigin = getPublicApiBaseUrl();
  if (typeof window !== 'undefined') {
    const href = apiOrigin ? `${apiOrigin}${path}` : path;
    if (import.meta.env.PROD && !apiOrigin && href.startsWith('/')) {
      // Fallback same-origin `/api` only works when Vercel proxies /api→Railway; prefer VITE_API_URL.
      console.warn(
        '[myKOL] OAuth: set VITE_API_URL or VITE_PUBLIC_API_URL at build time (e.g. https://api.kol.my)'
      );
    }
    window.location.href = href;
  }
}
